import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export const useUpdateComplianceSettings = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((setting) => api.base
        .put('/api/settings/UpdateComplianceSettings', setting)
        .then(res => res.data), {
        onSuccess: (_result, setting) => {
            queryClient.setQueriesData([SettingsQueryKey.CompanySettings], (old) => {
                if (!(old === null || old === void 0 ? void 0 : old.complianceSettings))
                    return old;
                return Object.assign(Object.assign({}, old), { complianceSettings: old.complianceSettings.map((cs) => cs.complianceType === setting.complianceType
                        ? Object.assign(Object.assign({}, cs), { shouldTrack: setting.shouldTrack }) : cs) });
            });
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateComplianceSettings: mutateAsync, isLoading };
};
